import { render, staticRenderFns } from "./ModalChatTicket.vue?vue&type=template&id=5811e7a6&"
import script from "./ModalChatTicket.vue?vue&type=script&lang=ts&"
export * from "./ModalChatTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports